<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md6 sm12 lg6 first-row>
        <material-card :key="dataLoaded">
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Npo details</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1' && !npo.canBeEdited"
              @click.stop="enableEditing()"
              >Edit Npo</v-btn
            >
            <v-btn
              class="ma-2"
              color="pink"
              v-if="npo.canBeEdited"
              @click.stop="updateNpo(npoDetails)"
              >Save Changes</v-btn
            >
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="npo.canBeEdited"
              @click.stop="cancelEditing()"
              >Cancel</v-btn
            >
          </v-toolbar>
          <v-form ref="npoForm">
            <v-form-base v-bind:value="npoDetails" v-bind:schema="npoSchema" />
          </v-form>
          <v-divider></v-divider>
          <area-panel
          :entityType="'npo'"
          :entityId="$route.params.npoId * 1"
          :canEdit="canEdit"
        />
        </material-card>
      </v-flex>
      <!-- Contacts -->
      <v-flex md6 sm12 lg6 first-row>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Logo</v-toolbar-title>
            <v-spacer></v-spacer>
            <upload-form
              :uploadFieldLabel="'Select logo'"
              @file-submitted="uploadLogo"
            />
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1'"
              @click="deleteLogo"
            >Clear<v-icon
        right
        dark
      >
        mdi-delete
      </v-icon></v-btn>
          </v-toolbar>
          <v-img
            :src="'data:image/png;base64,' + npoDetails.logo"
            aspect-ratio="1.7"
            contain
          ></v-img>
        </material-card>
        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Contacts</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              v-if="loggedUser.role === '1' && orderedContacts.length < 2"
              @click.stop="contactDialog = true"
            >Add contact</v-btn>
          </v-toolbar>
          <contact-card
            v-for="contact in orderedContacts"
            :key="contact.contact_type_id"
            :contact="contact"
            @contact-updated="updateContact"
          />
          <div v-if="orderedContacts.length === 0 " class="py-8 text-center">There are no contacts</div>
        </material-card>

        <material-card>
          <v-toolbar slot="header" color="primary" class="elevation-4">
            <v-toolbar-title>Campaigns</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2"
              outlined
              color="white"
              @click="getAvailableCampaigns"
              >Associate Campaign</v-btn
            >
          </v-toolbar>
          <v-data-table
            :headers="tableHeaders"
            :items="npoCampaigns"
            :options.sync="options"
            :loading-text="'Loading Campaigns ...'"
            :loading="npoCampaignsLoading"
            class="elevation-1"
            :footer-props="{
              'items-per-page-options': [10, 15, 20, 30, 50],
            }"
            :items-per-page="15"
          >
            <template v-slot:item.status_name="{ item }">
              <v-chip :color="getStatusColor(item.status)" dark>{{
                item.status_name
              }}</v-chip>
            </template>
            <template v-slot:item.name="{ item }">
              <a @click="goToCampaign(item)" dark>{{ item.name }}</a>
            </template>
            <template v-slot:item.campaign_attributes.end_date="{ item }">{{
              item.campaign_attributes.end_date | formatDateSmall
            }}</template>
            <template v-slot:item.action="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="
                  $router.push({
                    name: 'campaigndetail',
                    params: { campaignId: item.id + '' },
                  })
                "
                >mdi-square-edit-outline</v-icon
              >
              <v-icon small @click="disassociateCampaignDialog(item)"
                >mdi-delete</v-icon
              >
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-flex md12 sm12 lg12>
        <NpoBannerPanel v-if="npoId" :entityId="npoId"/>
      </v-flex>

      <v-flex md12 sm12 lg12>
        <material-card>
          <v-toolbar slot="header" color="primary">
            <v-toolbar-title>Donations</v-toolbar-title>
          </v-toolbar>

          <v-data-table
            :headers="donationsTableHeaders"
            :items="donationsTableContent"
            :options.sync="options"
            :server-items-length="totalDonationsTableContent"
            :loading="donationsLoading"
            class="elevation-1"
          >
            <template slot="headerCell" slot-scope="{ header }">
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
          </v-data-table>
        </material-card>
      </v-flex>

      <v-dialog v-model="campaignAssociateDialog" persistent max-width="400px">
        <v-card>
          <v-card-title>Associate Campaign</v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-form ref="npoAssociation" v-model="npoAssociationForm.valid">
              <v-combobox
                v-model="associatedCampaign"
                :items="availableCampaignsList"
                label="Campaign"
                item-value="campaign_id"
                item-text="name"
                clearable
                deletable-chips
                :rules="[(v) => !!v || 'Campaign is required']"
                multiple
                small-chips
              ></v-combobox>
            </v-form>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="secondary darken-1"
              outlined
              @click="campaignAssociateDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              color="primary darken-1"
              @click="associateCampaign(associatedCampaign)"
              >Associate Campaign</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="campaignDisassociateDialog"
        scrollable
        max-width="400px"
      >
        <v-card>
          <v-card-title>Disassociate Campaign</v-card-title>
          <v-card-text
            >Do you really want to disassociate Campaign
            {{ disassociatedCampaign.name }} ?</v-card-text
          >
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              color="secondary darken-1"
              outlined
              @click="campaignDisassociateDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              color="primary darken-1"
              @click="
                disassociateCampaign(disassociatedCampaign.id);
                campaignDisassociateDialog = false;
              "
              >Disassociate Campaign</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <contact-dialog
    :show="contactDialog"
    @hide-dialog="onContactCreation"
    :entityType="'npos'"
    :entityId="+this.$route.params.npoId"
  />
  </v-container>
</template>

<script>
import apiService from '@/services'
import ContactCard from '@/components/common-components/ComponentContactCard'
import { mapState } from 'vuex'
import contactDialog from '@/components/common-components/ComponentContactDialog'
import UploadForm from '@/components/npos/ComponentUpload'
import VFormBase from 'vuetify-form-base'
import AreaPanel from '@/components/common-components/ComponentAreaPanel'
import NpoBannerPanel from '@/components/giftcard/NpoBannerPanel.vue'

const formRules = {
  required: (field) => (v) => (v && v.length > 0) || `${field} is required`,
  requiredSelect: (field) => (v) => v || `${field} is required`,
  validEmail: (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
}

export default {
  components: {
    ContactCard,
    UploadForm,
    VFormBase,
    AreaPanel,
    contactDialog,
    NpoBannerPanel
  },

  computed: {
    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas']),
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    loggedIn () {
      return this.auth.loggedIn
    },
    loggedUser () {
      return this.auth.user || null
    },
    canEdit () {
      return this.auth.user.role === '1'
    },
    areaOptions () {
      // Transform status value into a string
      const areas = this.interventionAreas.map((i) => {
        i.area_id = i.area_id + ''
        return i
      })
      return areas
    },
    orderedContacts () {
      return _.orderBy(this.npoContacts, 'contact_type_id')
    },
    npoSchema () {
      return {
        name: {
          type: 'text',
          label: 'Name',
          flex: 12,
          readonly: this.npo.canBeEdited === false,
          rules: [formRules.required('Name')]
        },
        description: {
          type: 'textarea',
          label: 'Description',
          flex: 12,
          maxlength: 1500,
          counter: 1500,
          readonly: this.npo.canBeEdited === false,
          rules: [formRules.required('Description')]
        },
        fiscal_code: {
          type: 'text',
          label: 'Fiscal code',
          flex: 12,
          readonly: this.npo.canBeEdited === false,
          counter: 11,
          // mask: '###########',
          rules: [
            formRules.required('Fiscal code'),
            (v) => (v && v.length <= 11) || `Fiscal code must be 11 characters`
          ]
        },
        vat_number: {
          type: 'text',
          label: 'Vat number',
          flex: 12,
          readonly: this.npo.canBeEdited === false,
          counter: 11,
          // mask: '###########',
          rules: [
            (v) => (v && v.length <= 11) || `Vat number must be 11 characters`
          ]
        },
        iban: {
          type: 'text',
          label: 'Iban',
          flex: 12,
          counter: 27,
          maxlength: 27,
          rules: [
            (v) => !v || v.length === 27 || `Iban must be 27 characters long`
          ]
        },
        address: {
          type: 'text',
          label: 'Address',
          flex: 6,
          readonly: this.npo.canBeEdited === false
        },
        zip_code: {
          type: 'text',
          label: 'Zip code',
          mask: '#####',
          counter: 5,
          flex: 6,
          readonly: this.npo.canBeEdited === false,
          rules: [
            (v) => !v || v.length === 5 || `Zip Code must be 5 characters long`
          ]
        },
        city: {
          type: 'text',
          label: 'City',
          flex: 6,
          readonly: this.npo.canBeEdited === false
        },
        province: {
          type: 'text',
          label: 'Province',
          flex: 6,
          readonly: this.npo.canBeEdited === false
        },
        status: {
          type: 'select',
          label: 'Status',
          items: this.statuses.npos,
          itemValue: 'id',
          itemText: 'status_name',
          rules: [(v) => !!v || 'Status is required'],
          flex: { xs: 12, sm: 6 },
          readonly: this.npo.canBeEdited === false
        },
        registration_status: {
          type: 'select',
          label: 'Registration status',
          items: this.activationStatusOptions,
          itemValue: 'value',
          itemText: 'text',
          rules: [(v) => !!v || 'Activation status is required'],
          flex: { xs: 12, sm: 6 },
          readonly: this.npo.canBeEdited === false
        }
      }
    }
  },

  data () {
    return {
      npoId: null,
      contactDialog: false,
      dataLoaded: false,
      file: null,
      campaignAssociateDialog: false,
      associatedCampaign: [],
      campaignDisassociateDialog: false,
      disassociatedCampaign: [],
      canBeEdited: false,
      npoAssociationForm: {
        valid: true
      },
      availableCampaignsList: [],

      // Activation status options are hardcoded for now
      activationStatusOptions: [
        {
          text: 'Not pre-approved',
          value: 0
        },
        {
          text: 'Pre-approved',
          value: 1
        },
        {
          text: 'Waiting for approval',
          value: 2
        },
        {
          text: 'Approved',
          value: 3
        },
        {
          text: 'Not approved',
          value: 4
        }
      ],
      npoContacts: [],
      npo: {
        canBeEdited: false
      },
      clientDetails: {
        canBeEdited: false,
        data: {}
      },
      npoDetails: {},
      donationsTable: {},
      donationsTableHeaders: [
        { text: 'Id Json', value: 'jsonid' },
        { text: 'Data inserimento', value: 'insertdate' },
        { text: 'Totale', value: 'amount' }
      ],
      options: {},
      totalDonationsTableContent: 0,
      donationsTableContent: [],
      loading: true,
      donationsLoading: true,
      npoCampaigns: [],
      // Campaigns table
      tableHeaders: [
        {
          text: 'Campaign',
          align: 'left',
          sortable: true,
          value: 'name'
        },
        {
          text: 'Status',
          value: 'status_name',
          sortable: true
        },
        { text: 'Actions', value: 'action', sortable: false }
      ],
      npoCampaignsLoading: false,
      npoCampaignsTotal: 0
    }
  },

  mounted () {
    this.npoId = this.$route.params.npoId
    this.getNpo(this.$route.params.npoId)
    this.getNpoDonations(this.$route.params.npoId)
  },

  methods: {
    uploadLogo (formData) {
      const npoId = this.$route.params.npoId
      apiService.uploadNpoLogo('npos', formData, npoId).then((response) => {
        console.log(response)
        this.getNpo(this.$route.params.npoId)
      })
    },
    deleteLogo () {
      const data = {
        npo_id: this.$route.params.npoId * 1,
        logo: ''
      }
      apiService
        .updateNpo(data)
        .then(response => {
          this.getNpo(this.$route.params.npoId)
        })
        .catch(() => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error during logo deletion'
          })
        })
    },
    getNpo (npoId) {
      this.loading = true
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let filter = {}
      filter.sortBy = sortBy[0] || null
      filter.sortDesc = sortDesc[0] || null
      filter.page = page
      filter.itemsPerPage = itemsPerPage

      // GET npo con codice fiscale
      apiService
        .getNpo(npoId)
        .then((response) => {
          setTimeout(() => {
            this.npoDetails = response
            apiService.getEntityContacts('npo', npoId).then((response) => {
              let contacts = response || []
              this.npoContacts = contacts
            })

            apiService
              .fetchData('campaigns', { npo: npoId })
              .then((response) => {
                let contacts = response || []
                this.npoCampaigns = contacts
              })

            this.npoCampaignsLoading = false
            this.dataLoaded = !this.dataLoaded
            this.loading = false
          }, 800)
        })
        .catch(() => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Errore nel caricamento dei dati'
          })
        })
    },

    updateNpo (npoDetails) {
      this.loading = true
      if (!this.$refs.npoForm.validate()) {
        return
      }

      const data = this.npoDetails
      data.npo_id = this.$route.params.npoId * 1

      // Aggiorna npo con codice fiscale
      apiService
        .updateNpo(data)
        .then((response) => {
          setTimeout(() => {
            this.loading = false
            this.$store.dispatch('alert/showSnackbar', {
              color: 'success',
              text: 'Npo aggiornata con successo'
            })
          }, 800)
          this.npo.canBeEdited = false
        })
        .catch((error) => {
          console.log(error)
          setTimeout(() => {
            this.loading = false
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: 'Error updating Npo'
            })
          }, 800)
        })
    },

    /**
     * Contacts editing
     */

    updateContact (contact) {
      // Aggiorna client con client_id
      apiService
        .updateContact(contact)
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Contact updated succesfully`
          })
          // Close edit menu
          this.editContact = !this.editContact
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Cannot update contact'
          })
          // Close edit menu
          this.editContact = !this.editContact
        })
    },

    getNpoDonations (fiscalCode) {
      this.donationsLoading = false
    },

    enableEditing () {
      // Change control variable value
      this.npo.canBeEdited = true
      // Save backup data
      this.npo.backup = this.npoDetails
    },

    cancelEditing () {
      // Change control variable value
      this.npo.canBeEdited = false
      // Restore backup data
      this.npoDetails = this.npo.backup
      // Clear backup data
      this.npo.backup = {}
    },

    editNpo (data) {
      // Update Campaign based on campaign_id
      apiService
        .updateNpo(data)
        .then((response) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: 'Npo succesfully updated'
          })
          // Close edit menu
          this.npo.canBeEdited = !this.npo.canBeEdited
        })
        .catch(() => {
          this.loading = false
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: 'Error updating Campaign'
          })
          // Close edit menu
          this.npo.canBeEdited = !this.npo.canBeEdited
        })
    },

    // Get Campaigns available for association given Npo Id
    getAvailableCampaigns () {
      apiService
        .getAvailableCampaigns(this.$route.params.npoId)
        .then((response) => {
          console.log(response)
          this.availableCampaignsList = response
          this.campaignAssociateDialog = true
        })
    },

    associateCampaign (campaignIds) {
      console.log('IDS', campaignIds)
      const a = []

      campaignIds.map((i) => {
        a.push(i.id)
        return i.id
      })

      for (let campaign in a) {
        const data = {
          npo_id: this.$route.params.npoId * 1,
          campaign_id: a[campaign]
        }

        apiService
          .associateNpoCampaign(data)
          .then((response) => {
            this.getNpo(this.$route.params.npoId)
          })
          .then(() => {
            this.campaignAssociateDialog = false
            this.associatedCampaign = []
          })
          .catch((error) => {
            console.log(error)
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: `Cannot associate Npo`
            })
          })
      }
    },

    /**
     *  Open disassociation dialog
     */
    disassociateCampaignDialog (campaign) {
      this.disassociatedCampaign = campaign
      this.campaignDisassociateDialog = true
    },

    /**
     * Disassociate Campaign from Npo
     */
    disassociateCampaign (campaignId) {
      const params = {
        npo_id: this.$route.params.npoId,
        campaign_id: campaignId
      }
      apiService
        .disassociateNpo(params)
        .then((response) => {
          this.getNpo(this.$route.params.npoId)
        })
        .then(() => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'success',
            text: `Campaign succesfully disassociated`
          })
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot disassociate Campaign`
          })
        })
    },

    onContactCreation () {
      this.getNpo(this.$route.params.npoId)
      this.contactDialog = false
    },

    goToCampaign (item) {
      this.$router.replace({
        name: 'campaigndetail',
        params: { campaignId: item.id }
      })
    },

    // TO DO save statuses and properties in store - Riccardo Cosentino 04052020
    getStatusColor (status) {
      if (status === '1') return 'green'
      else if (status === '2') return 'red'
      else return 'gray'
    }
  }
}
</script>
